<template>
  <a-card>
    <a-row class="mb-3" :gutter="16">
      <a-col><p class="title">Enter Facebook Page URL</p></a-col>
      <a-col :flex="1">
        <a-row justify="end" :gutter="16"
          ><a-col
            ><FacebookLogin
              source="facebook"
              scopes="pages_show_list"
              app-id="1713627038673709"
              @authenticated="loadData"
            ></FacebookLogin></a-col
          ><a-col></a-col
        ></a-row>
      </a-col>
    </a-row>

    <a-row type="flex" :gutter="16">
      <a-col flex="1">
        <a-form ref="ruleForm" :model="form" :rules="rules" @submit="reValidate">
          <a-form-item name="resolveUrl" :validate-first="true">
            <a-input
              v-model:value="form.resolveUrl"
              type="text"
              placeholder="https://www.facebook.com/InsightEraTH/"
              autocomplete="off"
            />
          </a-form-item>
        </a-form>
      </a-col>
      <a-col>
        <a-button
          v-if="validateInfos.resolveUrl.validateStatus == 'success'"
          type="primary"
          size="default"
          :loading="isResolve"
          @click="resolveFacebookPage"
        >
          Resolve
        </a-button></a-col
      >
    </a-row>
    <AddFacebookPage
      v-if="pageInfo"
      :page-info="pageInfo"
      :visible="addPageVisible"
      @close="addPageVisible = false"
      @success="addPageSuccess"
    ></AddFacebookPage>
  </a-card>
</template>

<script>
import { ref, reactive, computed, watch } from 'vue';
import AddFacebookPage from './AddFacebookPage.vue';
import { useStore } from 'vuex';
import api from '@/services/api';
import { Form, notification } from 'ant-design-vue';
import FacebookLogin from '@/components/Facebook/FacebookLogin.vue';
export default {
  components: { AddFacebookPage, FacebookLogin },
  setup() {
    const useForm = Form.useForm;

    const store = useStore();
    const isResolve = ref(false);
    const pageInfo = ref({});
    const addPageVisible = ref(false);
    const ruleForm = ref(0);
    const form = reactive({
      resolveUrl: '',
    });

    const fanpageInfos = computed(() => store.getters['sourceSetting/fanpages']);
    const checkFanpageExist = async () => {
      if (form.resolveUrl) {
        try {
          let result = await api.resolveFacebookPageInfo(form.resolveUrl);

          let isExist = fanpageInfos.value.filter((v) => v.id === result.message.facebookId)[0];
          if (isExist) return Promise.reject('Added url is already exist');
          else Promise.resolve();
        } catch (error) {
          return Promise.resolve();
        }
      } else {
        return Promise.resolve();
      }
    };

    const rules = reactive({
      resolveUrl: [
        { required: true, message: 'Please input fanpage url', trigger: 'change' },
        {
          pattern: new RegExp('https://www.facebook.com/.+/?', 'g'),
          message: 'URL is incorrect or not exist',
          trigger: 'change',
        },
        {
          validator: checkFanpageExist,
          trigger: 'change',
        },
      ],
    });

    const resolveFacebookPage = async () => {
      isResolve.value = true;
      try {
        let result = await api.resolveFacebookPageInfo(form.resolveUrl);

        pageInfo.value = {
          accountId: store.state.account.brand,
          link: result.message.link,
          name: result.message.fanpageName,
          id: result.message.facebookId,
          profilePictureURL: result.message.profilePictureURL,
        };
        addPageVisible.value = true;
      } catch (error) {
        notification.error({
          message: 'Error',
          description: `Resolve ${form.resolveUrl} failed.`,
        });
      }
      isResolve.value = false;
    };

    const addPageSuccess = async () => {
      addPageVisible.value = false;
      form.resolveUrl = '';
      await store.dispatch('sourceSetting/getFanpages');
      setTimeout(() => {
        pageInfo.value = null;
      }, 200);
    };

    const { validateInfos, validate } = useForm(form, rules);
    const reValidate = () => {
      validate();
    };
    watch(
      () => form.resolveUrl,
      (url) => {
        if (!url) {
          ruleForm.value.resetFields();
        }
      }
    );

    const loadData = async () => {
      await store.dispatch('sourceSetting/getFanpages');
    };

    return {
      ruleForm,
      isResolve,
      form,
      rules,
      pageInfo,
      addPageVisible,
      resolveFacebookPage,
      addPageSuccess,
      reValidate,
      validateInfos,
      fanpageInfos,
      loadData,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: DM Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: '#272B41';
}

.text-danger {
  font-family: DM Sans;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #ff4d4f;
}

.mt-6 {
  margin-top: 6px;
}
</style>
